module.exports = __webpack_public_path__ + "static/media/newheroimgL.9ba7f94b.svg";